const SvgIconSearch = (props) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      d="M7.092 0a7.091 7.091 0 0 1 7.092 7.092 7.054 7.054 0 0 1-1.123 3.82l2.791 2.791a.508.508 0 0 1 0 .716l-1.433 1.433a.508.508 0 0 1-.717 0l-2.79-2.791a7.054 7.054 0 0 1-3.82 1.123A7.092 7.092 0 1 1 7.092 0zm0 12.158a5.072 5.072 0 0 0 5.066-5.066 5.072 5.072 0 0 0-5.066-5.066 5.071 5.071 0 0 0-5.065 5.066 5.071 5.071 0 0 0 5.065 5.066z"
      fillRule="nonzero"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconSearch
